















































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Resolve } from 'vue-di';
import SectionModule from '~/store/section';
import DocumentUploadModule from '~/store/documentUpload';
import PatientSupportServices from '~/store/patientSupportServices';

@Component<Header>({
})
export default class Header extends Vue {
    @Resolve
    public sectionStore!: SectionModule;

    @Resolve
    uploadModule!: DocumentUploadModule;

    @Resolve
    patientSupportServiceStore!: PatientSupportServices;

    redirectToLandingPage() {
        this.patientSupportServiceStore.resetStore();
        this.uploadModule.clearStore();
        this.sectionStore.resetSelections();
        this.$router.push('/');
    }
    public get headerLogoGlatopa() {
        return this.$settings.url(this.$settings.headerLogoGlatopa);
    }
    public get headerLogoLine() {
        return this.$settings.url(this.$settings.headerLogoLine);
    }
    public get headerLogoTreptrostinil() {
        return this.$settings.url(this.$settings.headerLogoTreptrostinil);
    }

}
